import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {

  init({ state, dispatch }) {},

  fetchBenchmarkReport(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/reports/reportbenchmark/${query}`).then((response) => {
      return response.data
    })
  },

  fetchBenchmarkReportnoset(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/reports/reportbenchmarknoset/${query}`).then((response) => {
      return response.data
    })
  },

  fetchConsolidatedReport(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/reports/reportconsolidated/${query}`).then((response) => {
      return response.data
    })
  },

  fetchConsolidatedReportnoset(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/reports/reportconsolidatednoset/${query}`).then((response) => {
      return response.data
    })
  },

}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}